import { render, staticRenderFns } from "./ExtFields.vue?vue&type=template&id=7cf3a99c&scoped=true&"
import script from "./ExtFields.vue?vue&type=script&lang=js&"
export * from "./ExtFields.vue?vue&type=script&lang=js&"
import style0 from "./ExtFields.vue?vue&type=style&index=0&id=7cf3a99c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf3a99c",
  null
  
)

export default component.exports